if (!customElements.get('pg-product-shelf')) {
  customElements.define(
    'pg-product-shelf',
    class PgProductShelf extends HTMLElement {
      connectedCallback() {
        this.shuffleButton = this.querySelector('[data-pg-shuffle]');
        this.productList = this.querySelector('[data-pg-product-list]');
        this.status = this.querySelector('[data-pg-shuffle-status]');
        this.shuffleCount = 0;

        if (!this.shuffleButton || !this.productList || this.shuffleButton.dataset.bound === 'true') return;

        this.shuffleButton.dataset.bound = 'true';
        this.shuffleButton.addEventListener('click', () => this.shuffleProducts());
      }

      shuffleProducts() {
        const products = Array.from(this.productList.children);
        const visibleLimit = Number.parseInt(this.productList.dataset.pgVisibleLimit, 10) || 8;
        const previousOrder = [...products];
        const previouslyVisible = new Set(products.filter((product) => !product.hidden));

        for (let index = products.length - 1; index > 0; index -= 1) {
          const swapIndex = Math.floor(Math.random() * (index + 1));
          [products[index], products[swapIndex]] = [products[swapIndex], products[index]];
        }

        const shownCount = Math.min(visibleLimit, products.length);
        const visibleSetUnchanged =
          products.length > shownCount && products.slice(0, shownCount).every((product) => previouslyVisible.has(product));

        if (visibleSetUnchanged) {
          [products[shownCount - 1], products[shownCount]] = [products[shownCount], products[shownCount - 1]];
        } else if (products.length === shownCount && products.every((product, index) => product === previousOrder[index])) {
          products.push(products.shift());
        }

        products.forEach((product, index) => {
          product.hidden = index >= shownCount;
          this.productList.append(product);
        });
        this.shuffleCount += 1;

        if (this.status) {
          this.status.textContent = `Shelf shuffled ${this.shuffleCount} ${
            this.shuffleCount === 1 ? 'time' : 'times'
          }. Showing ${shownCount} of ${products.length} products.`;
        }
      }
    }
  );
}
